import { HttpClient, HttpStatusCode } from 'data/protocols/http';
import { generateUrl } from 'data/utils';
import { InvalidCredentialsError, UnexpectedError } from 'domain/errors';
import { GetPerformanceReportForProfessionalsEvolutionUseCaseInterface } from 'domain/usecases';

type EvolutionApiResponse = {
  data?: GetPerformanceReportForProfessionalsEvolutionUseCaseInterface.Result;
};

export class RemoteGetPerformanceReportForProfessionalsEvolution
  implements GetPerformanceReportForProfessionalsEvolutionUseCaseInterface
{
  constructor(
    private readonly url: string,
    private readonly httpClient: HttpClient<EvolutionApiResponse>,
  ) {}

  async execute(
    params: GetPerformanceReportForProfessionalsEvolutionUseCaseInterface.Params,
  ): Promise<GetPerformanceReportForProfessionalsEvolutionUseCaseInterface.Result> {
    const requestUrl = generateUrl(this.url, params as any);

    const httpResponse = await this.httpClient.request({
      method: 'get',
      url: requestUrl,
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body?.data || [];
      case HttpStatusCode.forbidden:
        throw new InvalidCredentialsError();
      default:
        throw new UnexpectedError(httpResponse.body.message);
    }
  }
}
